<template>
  <div class="personal-center">
    <enfold>
      <div class="main">
        <div class="m-top">
          <div class="info">
            <img src="@/assets/images/me/public_edit.png" class="editimg" @click="editPerson" />
            <div class="peron-info">
              <div class="flex-d-b-c persons">
                <div class="person-logo">
                  <!-- <img src="../../assets/images/user_icon.jpg" /> -->
                  <div class="user-avatar">
                    <img :src="isDefaultUserAvatar?defaultUserAvatar:`/upload/userAvatar/${this.$cookies.get('user_id')}.png`" alt />
                    <div class="user-avatar-edit">
                      <el-upload accept=".png" class="upload-demo" :action="'/api'+'/admin/access/updateLayoutImg'" :on-success="handleSuccess" :before-upload="(file)=>{beforeAvatarUpload(file,'user_avatar')}" :data="uploadParams">
                        <i class="icon el-icon-edit-outline" style="color: #fff;" @click="editUserAvatar"></i>
                      </el-upload>
                    </div>

                  </div>
                  <!-- <span>{{$cookies.get("realname") || $cookies.get("username")}}</span> -->
                </div>
                <div class="button admin">{{this.username}}</div>
              </div>
              <div class="flex-d-b-c persons">
                <div class="person-info">
                  <div class="content">{{this.realname}}</div>
                  <div class="content">
                    <div class="co-left">{{$t('terminal.structure')}}:</div>
                    <div class="col-right">{{this.groupname}}</div>
                  </div>
                  <div class="content">
                    <div class="co-left">{{$t('system.email')}}:</div>
                    <div class="col-right">
                      <template v-if="useremail=='未设置'">
                        {{$t('system.noSet')}}
                      </template>
                      <template v-else>
                        {{useremail}}
                      </template>
                    </div>
                  </div>
                  <div class="content">
                    <div class="co-left">{{$t('system.lastLogin')}}:</div>
                    <div class="col-right">{{this.lastLoginTime}}</div>
                  </div>
                </div>
                <div class="button psw" @click="editPsw">{{$t('system.resetPwd')}}</div>
              </div>
            </div>
            <div class="control">
              <!-- <div class="button admin">{{this.username}}</div> -->
              <!-- <div class="button psw" @click="editPsw">重置密码</div> -->
            </div>
          </div>
        </div>
        <div class="m-bottom">
          <div class="imgs">
            <div class="bt-img bg-user" @click="goToAim('user')">
              <div class="conten">{{usertotal}}</div>
              <span class="title">{{$t('system.subUser')}}</span>
            </div>
            <div class="bt-img bg-device" @click="goToAim('terminal')">
              <div class="conten">{{onlinetotal}}/{{titletotal}}</div>
              <span class="title">{{$t('system.NumOfTerminals')}}</span>
            </div>
            <div class="bt-img bg-programe" @click="goToAim('play')">
              <div class="conten">{{programetotal}}</div>
              <span class="title">{{$t('system.NumOfPro')}}</span>
            </div>
            <!-- <div class="bt-img bg-ram">
							<div class="conten">{{ram}}</div>
							<span class="title">空间使用</span>
						</div> -->
          </div>
        </div>
      </div>
    </enfold>
    <form-dialog :dialogVisible="editPswDialog" @closeDialog="pswCloseDialog" :title="$t('system.editPwd')">
      <el-form ref="form" :model="form" :rules="pswrules" label-width="auto">
        <el-form-item label="旧密码" prop="oldpsw">
          <el-input v-model="form.oldpsw" type="password" show-password auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newpsw">
          <el-input v-model="form.newpsw" type="password" show-password auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkpsw">
          <el-input v-model="form.checkpsw" type="password" show-password autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="psw-control">
        <el-button round @click="cancelPsw('form')">{{$t('terminal.cancel')}}</el-button>
        <el-button round type="primary" @click="confimPsw('form')">{{$t('terminal.confirm')}}</el-button>

      </div>
    </form-dialog>
    <form-dialog :dialogVisible="editPersonDialog" @closeDialog="personCloseDialog" :title="$t('system.modifyInfo')">
      <el-form ref="personForm" :model="personForm" :rules="personrules" label-width="auto">
        <el-form-item :label="$t('system.changeNick')" prop="username">
          <el-input v-model="personForm.username"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.changeEmail')" prop="email">
          <el-input v-model="personForm.email"></el-input>
        </el-form-item>
      </el-form>
      <div class="psw-control">
        <el-button round @click="cancelPerson('personForm')">{{$t('terminal.cancel')}}</el-button>
        <el-button round type="primary" @click="confirmPerson('personForm')">{{$t('terminal.confirm')}}</el-button>
      </div>
    </form-dialog>
    <div class="fixed"><span>{{$t('system.personalCenter')}}</span></div>
  </div>
</template>

<script>
const EditUrl = '/admin/access/editMyself';
import Enfold from "@/components/basics/Enfold.vue";
import FormDialog from "@/components/basics/FormDialog"
import checkImageExists from '@/assets/scripts/checkImageExists.js';
import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";
import passwordStrength from '@/assets/scripts/passwordStrength.js'
export default {
  name: "PersonalCenter",
  components: {
    Enfold,
    FormDialog
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newpsw) {
        this.form.checkpsw = "";
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (passwordStrength(value).strength < 3) {
        callback(new Error('密码12位及以上且包含字母数字特殊字符'))
      } else {
        callback();
      }
    };
    return {
      username: '',
      groupname: '',
      realname: '',
      useremail: '',
      lastLoginTime: '',
      usertotal: '',
      onlinetotal: '',
      titletotal: '',
      programetotal: '',
      ram: '',
      rolename: '',
      editPswDialog: false,
      editPersonDialog: false,
      form: {
        oldpsw: '',
        newpsw: '',
        checkpsw: ''
      },
      personForm: {
        username: '',
        email: ''
      },
      pswrules: {
        oldpsw: [{ required: true, message: '请填写旧密码', trigger: 'blur' }],
        newpsw: [{ validator: passStrength, trigger: 'blur' }],
        checkpsw: [{ validator: validatePass, trigger: 'blur' }],
      },
      personrules: {
        username: [{
          required: true,
          message: this.$t('system.enterNick'),
          trigger: 'blur'
        }]
      },
      defaultUserAvatar: require("@/assets/images/user_icon.jpg"),
      isDefaultUserAvatar: true,
      uploadParams: {},
    }
  },
  methods: {
    editUserAvatar() {
      console.log("click");
    },
    beforeAvatarUpload(file, type) {
      let params = handleDataAndSign("/admin/access/updateLayoutImg", { img_type: type });
      this.$set(this.uploadParams, 'token', params.token);
      this.$set(this.uploadParams, 'v', params.v);
      this.$set(this.uploadParams, 't', params.t);
      this.$set(this.uploadParams, 's', params.s);
      this.$set(this.uploadParams, 'img_type', params.img_type);
      return true;
    },
    handleSuccess(res) {
      if (res.status === 1) {
        this.$msg({ message: res.tips, type: "success", showClose: true });
      } else {
        this.$msg({ message: res.tips, type: "warning", showClose: true });
      }
      this.$router.go(0);
    },
    editPsw() {
      this.editPswDialog = true;
    },
    editPerson() {
      this.editPersonDialog = true;
    },
    pswCloseDialog() {
      this.editPswDialog = false;
    },
    personCloseDialog() {
      this.editPersonDialog = false;
      //this.$refs['personForm'].resetFields();
      this.personForm.username = '';
      this.personForm.email = '';
    },
    cancelPsw(form) {
      this.$refs[form].resetFields();
      this.editPswDialog = false;
    },
    cancelPerson(form) {
      this.$refs[form].resetFields();
      this.editPersonDialog = false;
    },
    goToAim(type) {
      switch (type) {
        case 'user':
          this.$router.push({
            path: "userManage"
          });
          break;
        case 'terminal':
          this.$router.push({
            name: "Control"
          });
          break;
        case 'play':
          this.$router.push({
            name: "ProgramManage"
          });
          break;
        case 'total':
          // this.$router.push({
          // 	path: "/"
          // });
          break;

      }
    },
    confimPsw(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.newpsw !== this.form.checkpsw) {
            this.$msg({
              type: 'warning',
              message: this.$t('system.pwdNoPass')
            })
            this.$refs[formName].resetFields();
          } else {
            this.$http.post(EditUrl, {
              id: this.$cookies.get('user_id'),
              pwd_update: 1,
              pwd_original: this.form.oldpsw,
              pwd_new1: this.form.newpsw,
              pwd_new2: this.form.checkpsw
            }, (data) => {
              if (data.length == 0) {
                this.$msg({
                  type: 'success',
                  message: this.$t('system.changePwdSucc')
                });
                this.$cookies.keys().forEach(key => {
                  key !== 'rtp' && this.$cookies.remove(key);
                })
                this.$router.push({
                  path: "/"
                });
              } else {
                this.$msg({
                  type: 'warning',
                  message: data.tips
                });
                this.$refs[formName].resetFields();
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    confirmPerson(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post(EditUrl, {
            id: this.$cookies.get('user_id'),
            real_name: this.personForm.username,
            email: this.personForm.email
          }, data => {
            console.log(data);
            if (data.length == 0) {
              this.$msg({
                type: 'success',
                message: this.$t('system.modiSuccess')
              })
              this.getPersonInfo();
            } else {
              this.$msg({
                type: 'warning',
                message: this.$t('system.modiFail')
              })
            }
          });
          this.$refs[formName].resetFields();
          this.editPersonDialog = false;
        } else {
          return false;
        }
      });
    },
    getPersonInfo() {
      this.$http.post('/admin/access/myUserInfo', {
        id: this.$cookies.get('user_id')
      }, data => {
        this.username = data.myInfo.user_name;
        this.realname = data.myInfo.realname;
        this.groupname = data.myInfo.group_name;
        this.lastLoginTime = data.myInfo.login_time;
        this.useremail = data.myInfo.email == null ? '未设置' : data.myInfo.email;
        //this.personForm.email = data.myInfo.email == null ? '' : data.myInfo.email;
        this.rolename = data.myInfo.role_name;
      })
    },
    getUserList() {
      this.$http.post('/admin/access/userList', {
        group_ids: sessionStorage.getItem('group_ids')
      }, data => {
        this.usertotal = data.length - 1;
      })
    },
    getTerminalList() {
      this.$http.post('/admin/device/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: 1,
        page: 1,
      }, data => {
        this.titletotal = data.count;
        this.onlinetotal = data.count_ol;
      })
    },
    getPlayList() {
      this.$http.post('/admin/play/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: 1,
        page: 1,
      }, data => {
        this.programetotal = data.count;
      })
    }
  },
  created() {
    this.getPersonInfo();
    this.getUserList();
    this.getPlayList();
    this.getTerminalList();
    checkImageExists(`/upload/userAvatar/${this.$cookies.get('user_id')}.png`).then((res) => {
      console.log(res);
      this.isDefaultUserAvatar = !res;
    });
  }
}
</script>

<style lang="scss" scoped>
.personal-center {
  height: 100%;
  width: 100%;

  .main {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    overflow-y: auto;

    .m-top {
      width: 100%;
      height: 300px;
      background-color: rgba(17, 173, 248, 0.3);

      .info {
        width: 50%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 16px;
        position: relative;

        .editimg {
          position: absolute;
          top: 50px;
          right: 80px;
          width: 30px;
          height: 30px;
          cursor: pointer;
        }

        .peron-info {
          width: 500px;
          height: 500px;
          margin: 40px auto;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .persons {
            height: 100%;

            .button {
              height: 30px;
              line-height: 30px;
              font-size: 18px;
              padding-left: 5px;
              padding-right: 5px;
              border-radius: 15px;
              min-width: 30px;
              text-align: center;
            }

            .admin {
              min-width: 60px;
              background-color: rgba(48, 133, 161, 0.4);
              color: #ffffff;
              padding-left: 16px;
              padding-right: 16px;
              text-align: center;
            }

            .psw {
              color: #2fb3ff;
              border-style: solid;
              border-width: 1px;
              border-color: #2fb3ff;
              padding-left: 16px;
              padding-right: 16px;
              cursor: pointer;
            }
          }

          .person-logo {
            width: 150px;
            height: 150px;
            border: 2px solid #ffffff;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
            }
            .user-avatar:hover .user-avatar-edit {
              display: block;
            }
            .user-avatar {
              position: relative;
              .user-avatar-edit {
                width: 30px;
                height: 30px;
                position: absolute;
                bottom: 10px;
                left: 60px;
                z-index: 9999;
                font-size: 30px;
                display: none;
                cursor: pointer;
              }
            }
          }

          .person-info {
            margin-left: 20px;

            .content {
              height: 35px;
              line-height: 35px;
              font-family: PingFang-SC-Regular;
              color: #5487a0;
              display: flex;

              .co-left {
                width: 100px;
              }

              .co-right {
                padding-left: 10px;
                width: 160px;
                min-width: 160px;
              }
            }
          }
        }

        .control {
          width: 350px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: center;
          margin: 0 auto;
        }
      }
    }

    .m-bottom {
      width: 100%;
      height: 60%;
      position: relative;

      .imgs {
        width: 70%;
        height: 160px;
        margin: 100px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bt-img {
          width: 160px;
          height: 160px;
          border-radius: 4px;
          background-size: 100% 100%;
          position: relative;
          cursor: pointer;
        }

        .bg-user {
          background-image: url(~@/assets/images/me/bg_user.png);
        }

        .bg-device {
          background-image: url(~@/assets/images/me/bg_device.png);
        }

        .bg-programe {
          background-image: url(~@/assets/images/me/bg_programe.png);
        }

        .bg-ram {
          background-image: url(~@/assets/images/me/bg_RAM.png);
        }

        .title {
          position: absolute;
          padding: 0 5px 0 5px;
          white-space: nowrap;
          top: 70%;
          left: 50%;
          transform: translateX(-50%);
          color: #ffffff;
        }

        .conten {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -25px);
          font-size: 40px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }

  .psw-control {
    width: 180px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .fixed {
    position: fixed;
    left: 0;
    padding: 0 5px 0 3px;
    bottom: 3%;
    background-color: white;
    border-radius: 0vw 15px 15px 0vw;
    text-align: center;
    box-shadow: 0 0 5px 1px #999;

    span {
      font-family: PingFang-SC-Regular;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 30px;
      color: #2fb3ff;
    }
  }
}
</style>
